import { Chip } from "@mui/material";
import { styled } from "@mui/material/styles";
import { TextInput, useTranslate } from "react-admin";
import CustomFilterText from "../unit/CustomFilterText";

const QuickFilter = ({
  label,
}: {
  label: string;
  source?: string;
  defaultValue?: any;
}) => {
  const translate = useTranslate();
  return <Chip sx={{ marginBottom: 1 }} label={translate(label)} />;
};

const CampaignsListFilters = [
  <CustomFilterText label="ID" source="id" defaultValue="" />,
  <CustomFilterText label="Name" source="sName" defaultValue="" />,
];

export default CampaignsListFilters;
